module.exports = __webpack_public_path__ + "img/psm_logo.277467bd.png";